import { createFileRoute } from '@tanstack/react-router'
import { ChatPage } from '@/features/chat'

function ChatConversationRoute() {
  const { conversationId } = Route.useParams()
  return <ChatPage conversationId={Number(conversationId)} />
}

export const Route = createFileRoute('/chat/$conversationId')({
  component: ChatConversationRoute,
  staticData: { authorize: true, fullBleed: true },
})
